const JSON_HEADERS = {
  Accept: "application/json",
  "X-Requested-With": "XMLHttpRequest"
}

const HTML_HEADERS = {
  Accept: "text/html",
  "X-Requested-With": "XMLHttpRequest"
}

export async function fetchJson(url, { params = {}, signal, errorText }) {
  const response = await fetch(requestUrl(url, params), {
    headers: JSON_HEADERS,
    signal
  })

  const payload = await response.json()
  if (!response.ok) {
    throw new Error(payload.error || errorText)
  }

  return payload
}

export async function fetchHtml(url, { params = {}, signal, errorText }) {
  const response = await fetch(requestUrl(url, params), {
    headers: HTML_HEADERS,
    signal
  })

  const html = await response.text()
  if (!response.ok) {
    throw new Error(errorText)
  }

  return html
}

function requestUrl(url, params) {
  return `${url}?${new URLSearchParams(params).toString()}`
}